export default __webpack_public_path__ + "static/media/node-icon.3dc364b8.svg";